import type { Appearance } from '@stripe/stripe-js'

export const STRIPE_APPEARANCE: Appearance = {
  theme: 'stripe',
  variables: {
    colorPrimary: '#33cb9a',
    colorBackground: '#16181d',
    colorText: '#eeeeee',
    colorDanger: '#D6435B',
    fontFamily: 'Inter, system-ui, sans-serif',
    fontSizeBase: '13px',
    spacingUnit: '4px',
    borderRadius: '4px',
    colorTextPlaceholder: '#8a8e98'
  },
  rules: {
    '.Input': {
      backgroundColor: '#16181d',
      border: '1px solid #23262e',
      color: '#eeeeee',
      fontSize: '13px'
    },
    '.Input:focus': {
      borderColor: '#8a8e98',
      boxShadow: 'none'
    },
    '.Label': {
      color: '#ffffff',
      fontSize: '13px'
    }
  }
}
